<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-22 
-->
<template>
  <div class="index">
    <div class="countdown-bar" v-if="showCountdown">
      <div class="countdown-title">{{ countdownTitle }}</div>
      <div class="countdown-list">
        <div class="countdown-item" v-for="item in countdownList" :key="item.key">
          <div class="countdown-value">{{ item.value }}</div>
          <div class="countdown-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
    <div class="banner-mobile" @click="clickBanner(banner)" v-if="banner.img">
      <img :src="banner.img" />
    </div>
    <div class="banner-mobile" v-else></div>
    <!-- <div class="number-container" v-if="numberList.length && language == 'en'">
      <div class="number-list" v-if="numberList.length > 2">
        <swiper :options="swiperOption" ref="number-swiper">
          <swiper-slide class="swiper-no-swiping" v-for="item,index in numberList" :key="index">
            <div class="number-item">
              <div class="p1">
                <span class="sp1">{{item.number}}</span>
                <span class="sp2">{{item.unit}}</span>
              </div>
              <div class="p2">{{item.name}}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="number-list number-list2" v-else>
        <div class="number-item" v-for="item,index in numberList" :key="index">
          <div class="p1">
            <span class="sp1">{{item.number}}</span>
            <span class="sp2">{{item.unit}}</span>
          </div>
          <div class="p2">{{item.name}}</div>
        </div>
      </div>
    </div> -->
    <div class="btn-banner" v-if="btnBanner.length">
      <div class="btn-item" v-for="item,index in btnBanner" @click="clickBanner(item)">
        <img :src="item.img" />
        <div class="title">{{item.description}}</div>
      </div>
    </div>
    <div class="index-container">
      <!-- <div class="page-view" v-if="mainPageContent.length">
        <div class="page-title">
          <p class="p1">会+展+榜 三大版块</p>
          <p class="p2">CONFERENCE+EXHIBITION+AWARDS</p>
        </div>
        <div class="ecological">
          <div class="item" v-for="item,index in mainPageContent" :key="index">
            <div class="item-top">
              <div class="img-cnt">
                <img :src="item.imgPath | logo_show" class="bg-img">
              </div>
              <div class="title">
                <div v-if="language == 'zh'" v-html="item.showPageTitle"></div>
                <div v-else v-html="item.showEnPageTitle"></div>
              </div>
            </div>
            <div class="item-cnt">
              <img :src="static_img_url + `pic/sort`+(index + 1)+`.png`" class="sort-img" />
              <div class="desc">
                <div v-if="language == 'zh'" v-html="item.showContent"></div>
                <div v-else v-html="item.showEnContent"></div>
              </div>
              <div class="more-link" @click="handleClickPage(item.id, item.type)">{{'了解更多' | dealLanguage('More')}}</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="page-view reason-view">
        <div class="page-title">
          <p class="p1">{{'CSGCT 2026绝对不容错过' | dealLanguage('CSGCT Annual Meeting: Absolutely Unmissable')}}</p>
          <p class="reason-sub-title">{{'亚太地区最具国际影响力的细胞与基因治疗领域盛会' | dealLanguage('CSGCT Annual Meeting: Absolutely Unmissable')}}</p>
          <p class="p2"></p>
        </div>
        <div class="reason-list">
          <div class="reason-item" v-for="item,index in reasonList" :key="index">
            <i class="iconfont reason-icon" v-html="item.iconClass"></i>
            <div class="reason-title">{{item.title | dealLanguage(item.enTitle)}}</div>
            <div class="reason-desc">{{item.desc | dealLanguage(item.enDesc)}}</div>
          </div>
        </div>
        <swiper class="previous-swiper" :options="swiperOption2" ref="previous-swiper">
          <swiper-slide v-for="item,index in previousList2" :key="index">
            <div class="previous-item">
              <img :src="`${static_img_url}pic/previous2/${index + 1}.png`" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="page-view">
        <div class="page-title">
          <p class="p1">{{'大会亮点' | dealLanguage('HIGHLIGHTS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="high-light" v-if="language != 'en'">
          <img :src="`${static_img_url}pic/hl/hl.jpg`" />
        </div>
        <div class="high-light" v-else>
          <img :src="`${static_img_url}pic/hl/enhl.jpg`" />
        </div>
      </div>
      <div class="page-view" v-if="guestDtos.length">
        <div class="page-title">
          <p class="p1">{{'CSGCT核心专家库' | dealLanguage('PREVIOUS GUESTS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="speakers">
          <speaker-item v-for="item,index in guestDtos" :key="index" :itemDetail="item"></speaker-item>
        </div>
        <!-- <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('guests', '更多嘉宾')">更多嘉宾</div>
        </div> -->
      </div>
      <!-- <div class="page-view" v-if="activityExhibitionAreas.length">
        <div class="page-title">
          <p class="p1">特色展区</p>
          <p class="p2">FEATURED EXHIBITION AREA</p>
        </div>
        <div class="area">
          <div class="area-item" v-for="item,index in activityExhibitionAreas" :key="index" @click="handleClickAreas(item.id)">
            <div class="title">{{item.title | dealLanguage(item.enTitle)}}</div>
            <div class="mask2"></div>
            <img :src="item.imgPath | logo_show" class="bg-img" />
          </div>
        </div>
      </div> -->
      <div class="page-view" v-if="activityContentAppMiDtos.length">
        <div class="page-title">
          <p class="p1">{{'新闻资讯' | dealLanguage('NEWS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="news">
          <news-item v-for="item,index in activityContentAppMiDtos" :key="index" :itemDetail="item"></news-item>
        </div>
        <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('newsList', '更多新闻资讯')">{{'更多新闻资讯' | dealLanguage('More News')}}</div>
        </div>
      </div>

      <!-- <div class="page-view" v-if="language == 'en'">
        <div class="page-title">
          <p class="p1">{{'往届会议' | dealLanguage('PREVIOUS MEETING')}}</p>
          <p class="p2"></p>
        </div>
        <swiper class="previous-swiper" :options="swiperOption2" ref="previous-swiper">
          <swiper-slide v-for="item,index in previousList" :key="index">
            <div class="previous-item">
              <img :src="`${static_img_url}pic/previous/${index + 1}.jpg`" />
            </div>
          </swiper-slide>
        </swiper>
      </div> -->
      <div class="page-view" v-for="item,index in orgDtos" :key="index">
        <div class="page-title">
          <p class="p1">{{item.name | dealLanguage(item.enName)}}</p>
          <p class="p2"></p>
        </div>
        <div class="entitys">
          <entity-item v-for="eitem,eindex in item.list" :key="eindex" :itemDetail="eitem"></entity-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SpeakerItem from '@/components/index/speakerItem.vue'
import NewsItem from '@/components/index/newsItem.vue'
import EntityItem from '@/components/index/entityItem.vue'
import { getActExhibition } from '@/service/vbef'
import { Aadvertisement } from '@/service/app'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? this.activityDetail.name : this.activityDetail.enName,
    }
  },
  inject: ['globalInsertRecords', 'clickBanner', 'wxShare'],
  components: {
    SpeakerItem,
    NewsItem,
    EntityItem,
  },
  created() {
    this.getBanner()
    this.getActExhibition()
    this.dealMainPageContent()
  },
  beforeDestroy() {
    this.clearCountdownTimer()
  },
  mounted() {
    this.wxShare({
      title: this.language == 'zh' ? this.activityDetail.name : this.activityDetail.enName,
      linkurl: this.vbef_path,
    })
  },
  data() {
    return {
      numberList: [],
      actExhibitionDto: {},
      activityContentAppMiDtos: [],
      activityExhibitionAreas: [],
      guestDtos: [],
      orgDtos: [],
      banner: {},
      swiperOption: {
        slidesPerView: '2',
        autoplay: true,
        loop: true,
      },
      showMainPageContent: [],
      previousList: Array(16),
      previousList2: Array(6),
      reasonList: [
        {
          title: '国际化：全球创新力量齐聚',
          enTitle: 'Global Reach: Uniting Innovation Worldwide',
          iconClass: '&#xe706;',
          desc:
            '300+国际顶尖嘉宾从学术奠基人到产业领袖，覆盖美国、欧洲、中东及东南亚等地区，携前沿视野与协作意向汇聚北京。专设中国IIT资源对接会与海外BD对接会，构建链接全球临床资源与跨境资本的直通平台。',
          enDesc:
            '300+ top-tier international speakers — from academic pioneers to industry leaders, covering the United States, Europe, the Middle East, Southeast Asia, and beyond — bringing cutting-edge perspectives and collaboration intent to Beijing. Featuring dedicated China IIT Resource Matchmaking Session and Overseas BD Matchmaking Session, building a direct platform linking global clinical resources and cross-border capital.',
        },
        {
          title: '监管与临床：权威解读与深度链接',
          enTitle: 'Regulatory & Clinical: Authoritative Insights & Deep Connections',
          iconClass: '&#xe705;',
          desc:
            '监管专家现场拆解IND/BLA加速路径、北医三院、北大肿瘤、协和等头部临床PI分享最新试验数据，关键临床设计思路及临床试验策略。',
          enDesc:
            'Regulatory experts decode IND/BLA acceleration pathways on site. Leading clinical PIs from Peking University Third Hospital, Peking University Cancer Hospital, Peking Union Medical College Hospital, and others share the latest trial data, key clinical design approaches, and clinical trial strategies.',
        },
        {
          title: '全产业链：关键决策者齐聚',
          enTitle: 'Full Industry Chain: Key Decision Makers Gather',
          iconClass: '&#xe707;',
          desc:
            '超70%的参会代表为决策层，包括CGT创新药企、大型药企、科研院所及临床机构等关键决策方覆盖研发立项、工艺选择到商业化推进的全链条。',
          enDesc:
            'Over 70% of the attendees are decision-makers, including key stakeholders from CGT innovative biotech companies, large pharmaceutical firms, research institutes, and clinical institutions — covering the entire value chain from R&D project initiation and process selection to commercial advancement.',
        },
        {
          title: '全谱系：前沿技术全覆盖',
          enTitle: 'Full Spectrum: Complete Coverage of Cutting-Edge Technologies',
          iconClass: '&#xe708;',
          desc:
            '体内CAR-T、小核酸、外泌体、iPSC等前沿技术分支全覆盖，23场分论坛细分投资、递送、CMC、AI赋能等交叉议题，探讨各赛道产业化的真实进展。',
          enDesc:
            'Full coverage of frontier technology branches including in vivo CAR-T, small nucleic acids, exosomes, iPSC, etc. 23 sub-forums spanning cross-cutting topics such as financing & investment, delivery, CMC, AI-enabled drug discovery, exploring the real-world progress of industrialization across different tracks.',
        },
      ],
      swiperOption2: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        loop: true,
        autoplay: true,
      },
      showCountdown: false,
      countdownTimer: null,
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      mainPageContent: (state) => state.mainPageContent,
      vbef_path: (state) => state.vbef_path,
      language: (state) => state.language,
      btnBanner: (state) => state.btnBanner,
    }),
    countdownTitle() {
      return this.language == 'zh' ? '距离大会开始还有' : 'Countdown to Opening'
    },
    countdownList() {
      const labels =
        this.language == 'zh'
          ? { days: '天', hours: '时', minutes: '分', seconds: '秒' }
          : { days: 'Days', hours: 'Hours', minutes: 'Minutes', seconds: 'Seconds' }
      return [
        { key: 'days', value: this.countdown.days, label: labels.days },
        { key: 'hours', value: this.countdown.hours, label: labels.hours },
        { key: 'minutes', value: this.countdown.minutes, label: labels.minutes },
        { key: 'seconds', value: this.countdown.seconds, label: labels.seconds },
      ]
    },
  },
  watch: {
    'activityDetail.startTime': {
      immediate: true,
      handler(val) {
        this.initCountdown(val)
      },
    },
  },
  methods: {
    initCountdown(time) {
      this.clearCountdownTimer()
      const targetTime = this.parseCountdownTime(time)
      if (!targetTime) {
        this.showCountdown = false
        return
      }
      this.updateCountdown(targetTime)
      if (!this.showCountdown) return
      this.countdownTimer = setInterval(() => {
        this.updateCountdown(targetTime)
      }, 1000)
    },
    updateCountdown(targetTime) {
      const diff = targetTime - Date.now()
      if (diff <= 0) {
        this.showCountdown = false
        this.clearCountdownTimer()
        return
      }
      const totalSeconds = Math.floor(diff / 1000)
      const days = Math.floor(totalSeconds / 86400)
      const hours = Math.floor((totalSeconds % 86400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      this.countdown = {
        days: this.formatCountdownValue(days),
        hours: this.formatCountdownValue(hours),
        minutes: this.formatCountdownValue(minutes),
        seconds: this.formatCountdownValue(seconds),
      }
      this.showCountdown = true
    },
    parseCountdownTime(time) {
      if (!time) return 0
      const normalizedTime = String(time).replace(/-/g, '/')
      return new Date(normalizedTime).getTime()
    },
    formatCountdownValue(value) {
      return value > 9 ? String(value) : `0${value}`
    },
    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    dealMainPageContent() {
      this.showMainPageContent = [...this.mainPageContent]
      this.showMainPageContent.map((a) => {
        this.$set(a, 'showPageTitle', a.pageTitle.replace(/\n/g, '<br>'))
        this.$set(a, 'showEnPageTitle', a.enPageTitle.replace(/\n/g, '<br>'))
        this.$set(a, 'showContent', a.content.replace(/\n/g, '<br>'))
        this.$set(a, 'showEnContent', a.enContent.replace(/\n/g, '<br>'))
      })
    },
    async getBanner() {
      let res = await Aadvertisement({
        appAdPositionIds: this.language == 'zh' ? [128] : [126],
      })
      if (res.code == 0 && res.data.length) {
        this.$set(this.$data, 'banner', res.data[0])
      }
    },
    async getActExhibition() {
      let res = await getActExhibition({
        activityId: this.activityId,
        isEnglish: this.language == 'en' ? 1 : 0,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'actExhibitionDto', res.data.actExhibitionDto)

        this.$set(this.$data, 'activityContentAppMiDtos', res.data.activityContentAppMiDtos)
        this.$set(this.$data, 'activityExhibitionAreas', res.data.activityExhibitionAreas)
        this.$set(this.$data, 'guestDtos', res.data.guestDtos)
        
        let list = res.data.orgDtos
        let arr = []
        list.forEach((item) => {
          let index = arr.findIndex((ele) => ele.id == item.id)
          if (index == -1) {
            arr.push({ id: item.id, name: item.name, enName: item.enName, sortNum: item.sortNum, list: [item] })
          } else {
            arr[index].list.push(item)
          }
        })
        // arr 按照arr.sortNum排序
        arr.sort((a, b) => a.sortNum - b.sortNum)

        this.$set(this.$data, 'orgDtos', [...arr])
        
        if (this.language == 'zh') {
          let fDtos = res.data.actExhibitionDto.featureJsonObjDtos || []
          if (fDtos.length > 0) {
            fDtos = fDtos.filter((item) => item.name && item.number)
          }
          this.$set(this.$data, 'numberList', fDtos)
        } else {
          let fDtos = res.data.actExhibitionDto.enFeatureJsonObjDtos || []
          if (fDtos.length > 0) {
            fDtos = fDtos.filter((item) => item.name && item.number)
          }
          this.$set(this.$data, 'numberList', fDtos)
        }
      }
    },
    handleClickPage(itemid, itemtype) {
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 161,
        viewType: 1,
      })
      if (itemtype == 3) {
        window.location.href = 'https://vb100.vbdata.cn/Index/list'
      } else if (itemtype == 1) {
        this.$router.push({ name: 'agenda' })
      } else {
        this.$router.push({ name: 'exhibitionDesc', params: { id: 83 } })
      }
    },
    handleClickAreas(itemid) {
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 162,
        viewType: 1,
      })
      this.$router.push({ name: 'exhibitionDesc', params: { id: 2 } })
      // let index = this.mainPageContent.findIndex((item) => item.type == 2)
      // if (index > -1) {
      //   let current_id = this.mainPageContent[index].id
      // }
    },
    handleChangeRoute(name, kw) {
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      this.$router.push({ name })
    },
  },
}
</script>
<style lang='stylus' scoped>
.countdown-bar
  padding 0.28rem 0.24rem 0.32rem
  background linear-gradient(90deg, #c8161d 0%, #e94a08 100%)
  color #fff
  .countdown-title
    font-size 0.32rem
    line-height 0.45rem
    text-align center
    font-weight 700
  .countdown-list
    margin-top 0.2rem
    display flex
    justify-content space-between
    gap 0.12rem
  .countdown-item
    flex 1
    min-width 0
    padding 0.18rem 0.08rem
    border-radius 0.12rem
    background rgba(255, 255, 255, 0.14)
    text-align center
  .countdown-value
    font-size 0.4rem
    line-height 0.48rem
    font-weight 700
  .countdown-label
    margin-top 0.08rem
    font-size 0.2rem
    line-height 0.28rem
.banner-mobile
  height 5.38rem
  background #f0f0f0
  display flex
  justify-content center
  overflow hidden
  cursor pointer
  img
    width auto
    height 100%
.number-list
  background #FFF2EB
  padding 0.3rem 0
  &.number-list2
    display flex
    justify-content space-evenly
  .number-item
    text-align center
    padding 0 0.2rem
    .p1
      color #C8161D
      line-height 0.72rem
      font-family 'DINMittelschriftStd'
      .sp1
        font-size 0.6rem
      .sp2
        font-size 0.4rem
    .p2
      font-size 0.26rem
      color #47515F
      line-height 0.36rem
      margin-top -0.1rem
.btn-banner
  padding 0.3rem 0.4rem
  display flex
  .btn-item
    position relative
    flex 0 0 calc(50% - 0.15rem)
    background #C8161D
    padding 0.3rem
    border-radius 0.1rem
    &+.btn-item
      margin-left 0.3rem
    img
      width 0.52rem
      height 0.52rem
      display block
      margin 0 auto
    .title
      font-size 0.26rem
      color #FFFFFF
      line-height 0.36rem
      text-align center
      margin-top 0.16rem
    &:before
      content ''
      position absolute
      width 0.15rem
      height 0.15rem
      border-radius 50%
      top 0.16rem
      left 0.18rem
      background #FFFFFF
.index-container
  padding 0 0.4rem 0.5rem
  .page-view
    padding-top 0.4rem
    &+.page-view
      padding-top 1rem
    .page-title
      text-align center
      .p1
        font-size 0.32rem
        color #333333
        line-height 0.45rem
      .p2
        width 0.8rem
        height 0.04rem
        background #C8161D
        margin 0.1rem auto 0
  .more-link
    font-size 0.24rem
    color #c8161d
    line-height 0.28rem
    border-bottom 0.02rem solid #c8161d
    transition 0.3s
    cursor pointer
  .page-more
    margin-top 0.3rem
    display flex
    justify-content center
  .reason-view
    .reason-sub-title
      margin-top 0.18rem
      text-align center
      font-size 0.28rem
      line-height 0.4rem
      color #555555
    .reason-list
      margin-top 0.4rem
      display grid
      grid-template-columns 1fr
      grid-gap 0.24rem
    .reason-item
      background #FFFFFF
      border-radius 0.2rem
      box-shadow 0 0.08rem 0.24rem rgba(0, 0, 0, 0.08)
      padding 0.32rem 0.28rem
      .reason-icon
        color #C8161D
        font-size 0.56rem
      .reason-title
        margin-top 0.2rem
        font-size 0.34rem
        line-height 0.48rem
        color #C8161D
        font-weight 700
      .reason-desc
        margin-top 0.2rem
        font-size 0.26rem
        line-height 0.44rem
        color #666666
  .ecological
    margin-top 0.3rem
    .item
      background #FFFFFF
      box-shadow 0px 6px 16px 0px rgba(0, 0, 0, 0.1)
      cursor pointer
      &+div
        margin-top 0.4rem
      .item-top
        display flex
        align-items center
        .title
          font-size 0.32rem
          color #47515F
          line-height 0.5rem
          margin-left 0.2rem
          font-weight 700
        .img-cnt
          width 2.42rem
          height 2rem
          background #f0f0f0
          img
            width 100%
            height 100%
            object-fit cover
      .item-cnt
        padding 0.4rem 0.4rem 0.85rem
        position relative
        .sort-img
          position absolute
          height 0.4rem
          left 0.4rem
          top -0.2rem
          z-index 2
        .more-link
          position absolute
          bottom 0.26rem
          right 0.4rem
        .item-sort
          position absolute
        .desc
          font-size 0.26rem
          color #666666
          line-height 0.52rem
  .speakers
    margin-top 0.34rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 0.3rem 0.3rem
    & > :nth-child(2n+1)
      justify-self end
    & > :nth-child(2n)
      justify-self start
    >>> .speaker-item
      width 100%
      max-width 3.8rem
      min-width auto
      padding 0 0 0.4rem
      .header-img
        width 80%
        height 0
        padding-bottom 80%
        margin-top 20%
        max-height 3.8rem
        position relative
        img
          position absolute
      .name
        font-size 0.3rem
        line-height 0.42rem
        margin-top 0.22rem
        padding 0 0.4rem
      .title
        font-size 0.24rem
        line-height 0.36rem
        margin-top 0.11rem
        padding 0 0.4rem
        min-height 0.72rem
  .area
    margin-top 0.34rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 0.3rem 0.3rem
    .area-item
      height calc(60vw - 0.66rem)
      position relative
      overflow hidden
      .bg-img
        width 100%
        height 100%
        object-fit cover
      .mask2
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        background linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, rgba(216, 216, 216, 0) 100%)
        z-index 2
      .title
        position absolute
        left 0.2rem
        bottom 0.4rem
        right 0.2rem
        font-size 0.26rem
        color #FFFFFF
        line-height 0.28rem
        z-index 3
      &:active
        opacity 0.9
  .news
    margin-top 0.2rem
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-gap 0.3rem 0.3rem
    & > :nth-child(2n+1)
      justify-self end
    & > :nth-child(2n)
      justify-self start
    >>> .news-item
      width 100%
      max-width 4rem
      min-width auto
      .news-img
        height calc(28.13vw - 0.31rem)
        max-height 2.25rem
      .news-content
        padding 0.2rem
        .title
          font-size 0.24rem
          line-height 0.36rem
        .time
          font-size 0.22rem
          line-height 0.22rem
          margin-top 0.2rem
  .entitys
    margin-top 0.3rem
    display grid
    grid-template-columns repeat(3, 1fr)
    grid-gap 0.3rem 0.3rem
    >>> .entity-item
      width auto
      max-width none
      height 0.9rem
.previous-swiper
  width clac(100% + 0.8rem)
  height 4rem
  margin 0.3rem -0.4rem 0
  .swiper-slide
    width 5.4rem
    height 3.6rem
  .previous-item
    width 100%
    height 100%
    img
      width 100%
      height 100%
.high-light
  margin-top 40px
  img
    width 100%
</style>
